<!-- SCALE START INSTRUCTIONS MODAL -->
<div id="setScaleStartDialog" appDraggable dragTarget="#setScaleStartDialog" dragHandle="#setScaleStartHeader" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="scaleStartModalLabel">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<div id="setScaleStartHeader" class="modal-header">
				<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">X</span></button>
				<h4 class="modal-title" id="scaleStartModalLabel">SET SCALE</h4>
			</div>
			<div class="modal-body">
				<p>Draw a line from one point on the map to another point.</p>
				<p>Click to start the line, release the button, and click to end the line.</p>
				<p>When finished, you can specify how long that line was.</p>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal">CANCEL</button>
				<button type="button" class="btn btn-primary" (click)="okClicked()">OK</button>
			</div>
		</div>
	</div>
</div>